import axios from 'axios'

export const companiesCreditCards = {
  namespaced: true,
  state: {
    data: null,
    default_card_id: null,
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    apiFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
    readCreditCardsSuccess(state, payload) {
      state.data = payload
      state.default_card_id = payload.meta.default_card_id
      state.loading = false
    },
    writeCreditCardsSuccess(state, payload) {
      state.data.data.push(payload.data)
      state.loading = false
    },
    deleteCreditCardsSuccess(state, deleted_card_id) {
      state.data.data = state.data.data.filter(function(value){
        return value.id != deleted_card_id
      })
      state.loading = false
    },
    changeDefaultCreditCardsSuccess(state, default_card_id) {
      state.default_card_id = default_card_id
      state.loading = false
    },
  },
  actions: {
    readCreditCards({ commit }, companyUuid) {
      commit('apiConnect')
      axios
        .get('/api/companies/' + companyUuid + '/credit_cards.json')
        .then(res => {
          commit('readCreditCardsSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    writeCreditCards({ commit }, companyUuid) {
      commit('apiConnect')
      const payjsToken =  document.getElementsByName('payjp-token')[0].value
      const payload = { 'payjp-token': payjsToken }
      axios
        .post('/api/companies/' + companyUuid + '/credit_cards.json', payload)
        .then(res => {
          commit('writeCreditCardsSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    deleteCreditCards({ commit }, { companyUuid, card_id }) {
      commit('apiConnect')
      axios
        .delete('/api/companies/' + companyUuid + '/credit_cards/' + card_id + '.json')
        .then(() => {
          commit('deleteCreditCardsSuccess', card_id)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    changeDefaultCreditCards({ commit }, { companyUuid, card_id }) {
      commit('apiConnect')
      const payload = { 'card_id': card_id }
      axios
        .patch('/api/companies/' + companyUuid + '/default_credit_card.json', payload)
        .then(() => {
          commit('changeDefaultCreditCardsSuccess', card_id)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
  }
}
